module.exports = __webpack_public_path__ + "img/pause.dab6818e.png";